// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d36f50e0","453":"87bace99","667":"c5731dcc"}[chunkId] + ".chunk.js";
};